import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ImageText from "../common/imageText";
import ImageButtonList from "../common/imageButtonList";

class Popup extends Component {
  /**************
   * Properties *
   **************/
  exitImage = require("./images/Popup_Exit.png");
  exitButtons = [
    {
      id: "exit",
      to: "/feedback/list",
      highlight: require("./images/Popup_ExitSurvey_HL.png"),
      unhighlight: require("./images/Popup_ExitSurvey_UH.png"),
    },
    {
      id: "return",
      to: `/feedback/question/${this.props.match.params.survey}/${this.props.match.params.question}`,
      highlight: require("./images/Popup_ReturnSurvey_HL.png"),
      unhighlight: require("./images/Popup_ReturnSurvey_UH.png"),
    },
  ];
  submitImage = require("./images/Popup_Submitted.png");
  submitButtons = [
    {
      id: "submit",
      to: `/feedback/list/submit/${this.props.match.params.survey}`,
      className: "submit",
      unhighlight: require("./images/1210_popup_SelectContinue.png"),
    },
  ];

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    const textImage =
      this.props.popup === "submit" ? this.submitImage : this.exitImage;
    const buttons =
      this.props.popup === "submit" ? this.submitButtons : this.exitButtons;
    return (
      <div className="feedback-popup">
        <ImageText id="text" src={textImage} />
        <ImageButtonList imageButtons={buttons} flexClass="flex-vertical" />
      </div>
    );
  }
}

export default withRouter(Popup);
